export { MiscIconsSocial2 } from "./MiscIconsSocial2";
